<template>
<div>
    <h5 class="card-title">{{$t('content.lesson.upload')}}:</h5>
    <a target="_blank" :href="fileUrl" download>
        <span>
            <i class="mdi mdi-circle pr-1" :class="{'mdi-image' : data.type == 'image', 'mdi-file' : data.type == 'pdf', 'mdi-play' : data.type == 'video'}"></i>
        </span>{{data.translation.name}}
    </a>
</div>
</template>

<script>
export default {
    name: 'ContentUndefinedFile',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    computed: {
        fileUrl() {
            // Verificar se temos uma URL assinada para download no localStorage
            const signedApiUrls = localStorage.getItem(`lesson_${this.$route.params.lessonId}_api_urls`);

            if (signedApiUrls) {
                const apiUrls = JSON.parse(signedApiUrls);
                if (apiUrls && apiUrls.downloads && apiUrls.downloads[this.data.id]) {
                    return apiUrls.downloads[this.data.id].download;
                }
            }

            // Se não houver URL assinada, usar a URL normal
            return `/app/files/download/${this.data.id}/${this.data.secret}/show`;
        },
    },
};
</script>
